// **********************************************************
// Wishlist popup
// **********************************************************
function closePopups() {
  const allOpenPopups = document.querySelectorAll('.wishlist-popup.is-open');
  allOpenPopups.forEach((el) => {
    el.classList.remove('is-open');
  });
}

function initPopups() {
  const openPopups = document.querySelectorAll('.open-wishlist-popup');
  const openComparisonPopups = document.querySelectorAll('.card .compare-button');
  openPopups.forEach((openPopup) => {
    openPopup.addEventListener('click', () => {
      const parent = openPopup.closest('.card');
      const title = parent.querySelector('.card__title');
      const popup = parent.querySelector('.like-popup');
      const close = popup.querySelector('.wishlist-popup__close');
      const sliderParent = openPopup.closest('.swiper-slide');

      if (sliderParent) {
        if (openPopup.classList.contains('is-liked')) {
          closePopups();
          document.body.appendChild(popup);
          parent.classList.add('no-wishlist-btn');
          popup.classList.remove('added');
          popup.classList.add('is-open');
          popup.classList.add('removed');

          setTimeout(() => {
            popup.classList.remove('is-open');
            parent.classList.remove('no-wishlist-btn');
            title.appendChild(popup);
          }, 5000);

        } else {
          closePopups();
          document.body.appendChild(popup);
          parent.classList.add('no-wishlist-btn');
          popup.classList.remove('removed');
          popup.classList.add('is-open');
          popup.classList.add('added');

          setTimeout(() => {
            popup.classList.remove('is-open');
            parent.classList.remove('no-wishlist-btn');
            title.appendChild(popup);
          }, 5000);
        }

        close.addEventListener('click', () => {
          popup.classList.remove('is-open');
          parent.classList.remove('no-wishlist-btn');
          title.appendChild(popup);
        });
      } else if (openPopup.classList.contains('is-liked')) {
          closePopups();
          parent.classList.add('no-wishlist-btn');
          popup.classList.remove('added');
          popup.classList.add('is-open');
          popup.classList.add('removed');

          setTimeout(() => {
            popup.classList.remove('is-open');
            parent.classList.remove('no-wishlist-btn');
          }, 5000);

        } else {
          closePopups();
          parent.classList.add('no-wishlist-btn');
          popup.classList.remove('removed');
          popup.classList.add('is-open');
          popup.classList.add('added');

          setTimeout(() => {
            popup.classList.remove('is-open');
            parent.classList.remove('no-wishlist-btn');
          }, 5000);
        }

        close.addEventListener('click', () => {
          popup.classList.remove('is-open');
          parent.classList.remove('no-wishlist-btn');
        });
    });
  });

  openComparisonPopups.forEach((openComparisonPopup) => {
    openComparisonPopup.addEventListener('click', () => {
      if (openComparisonPopup.innerHTML !== openComparisonPopup.dataset.altertext) {
        const parent = openComparisonPopup.closest('.card__body');
        const popup = parent.querySelector('.comparison-popup');
        const sliderParent = openComparisonPopup.closest('.swiper-slide');

        if (sliderParent) {
          closePopups();
          document.body.appendChild(popup);
          popup.classList.remove('added');
          popup.classList.add('is-open');
          popup.classList.add('added');

          setTimeout(() => {
            popup.classList.remove('is-open');
          }, 5000);
        } else {
          closePopups();
          popup.classList.remove('added');
          popup.classList.add('is-open');
          popup.classList.add('added');

          setTimeout(() => {
            popup.classList.remove('is-open');
          }, 5000);
        }
      }
    });
  });
}

initPopups();

// **********************************************************
// Close popup
// **********************************************************
const wishlistPopups = document.querySelectorAll('.wishlist-popup');
wishlistPopups.forEach((wishlistPopup) => {
  const close = wishlistPopup.querySelector('.wishlist-popup__close');
  close.addEventListener('click', () => {
    wishlistPopup.classList.remove('is-open');
  });
});
